// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"835f1413","239":"6a3cbebd","455":"20838e9f","508":"77b0efac","776":"d785e346","977":"f5ee18c3"}[chunkId] + ".chunk.js";
};